// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PinSvg from '@rsuite/icon-font/lib/status/Pin';
var Pin = createSvgIcon({
  as: PinSvg,
  ariaLabel: 'pin',
  category: 'status',
  displayName: 'Pin'
});
export default Pin;